export interface BaseOption {
  id: string;
  name: string;
  regionId?: number;
}

export interface OptionsResponse {
  tenanCountry: BaseOption;
  countries: BaseOption[];
  regions: BaseOption[];
  cities: BaseOption[];
  communes: BaseOption[];
  healthInstitutions: BaseOption[];
  identificationTypes: BaseOption[];
  campuses: BaseOption[];
  schools: BaseOption[];
  // Statics
  genders: BaseOption[];
  areaTypes: BaseOption[];
  healthSystems: BaseOption[];
  maritalStatus: BaseOption[];
}

export enum AsynOptionsFieldsOrigin {
  StudentFile = 'student-file',
  InitialTuition = 'initial-tuition',
}
